import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NGXLogger } from "ngx-logger";
import { MenuItem, MessageService, SelectItem } from "primeng/api";

import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { EsitoConsegnaInfratel } from "src/app/models/dto/esitoConsegnaInfratel.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { ExcelService } from "src/app/services/excelService.service";
import { PraticheService } from "src/app/services/pratiche.service";
import { Timestamp } from "firebase/firestore";
import { AppuntamentoFase2 } from "src/app/models/dto/appuntamentoFase2.model";
import { UtilService } from "src/app/services/util.service";
import { ListeService } from "src/app/services/liste.service";
import { CategoriaVincolo } from "src/app/models/categoriaVincolo.model";
import { StiliService } from "src/app/services/stili.service";
import { MagazzinoService } from "../../../../../services/magazzino.service";
import {
  MagazzinoApiDescriptor,
  ModelloDispositivoApiDescriptor,
} from "../../../../../models/magazzino.model";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: "app-esito-appuntamento-fase2",
  templateUrl: "./dialog-esito_appuntamento_fase2.component.html",
  styleUrls: ["../shared.component.css"],
})
export class DialogComunicaEsitoAppuntamentoFase2 implements OnInit {
  protected _onDestroy = new Subject<void>();
  protected pratica: PraticaFlowdy2_Firestore;
  protected comunicaEsitoInstallazioneRouterForm: FormGroup;
  protected datiScuolaForm: FormGroup;
  protected datiCPEForm: FormGroup;
  protected isComunicandoInstallazioneRouter: boolean = false;

  protected pagineComunicaEsitoInstallazioneRouter: MenuItem[];
  protected activeIndex: number = 0;

  protected esitoOK: boolean = true;
  protected labelConferma: string = "Conferma";
  protected severityConferma: string = "";
  protected categorieAppuntamentoKO: CategoriaVincolo[] = [];

  esiti = [
    { label: "OK", value: "OK", styleClass: "esito-ok" },
    { label: "KO", value: "KO", styleClass: "esito-ko" },
  ];

  backup = [
    { label: "SI", value: "SI", styleClass: "esito-ok" },
    { label: "NO", value: "NO", styleClass: "esito-ko" },
  ];

  scortaMateriali: {
    [key: string]: {
      modello: ModelloDispositivoApiDescriptor;
      balance: number;
    };
  };

  regoleRegistrazioneMateriali: RegolaInstallazioneDispositivo[] = [
    {
      nmu: "780098",
      valueRequired: 1,
      requiresSerial: true,
    },
    {
      nmu: "780099",
    },
    {
      nmu: "780110",
    },
    {
      nmu: "780111",
    },
    {
      nmu: "780701",
    },
    {
      nmu: "780300",
    },
  ];

  installedNmus: string[] = this.regoleRegistrazioneMateriali.map((item) => {
    return item.nmu;
  });

  installedSerials: { [key: string]: string };
  installedAmounts: { [key: string]: number };

  materialsDiff: { [key: string]: number };
  hasMissingMaterials: boolean;
  hasMissingSerials: boolean;

  magazziniById: { [key: string]: MagazzinoApiDescriptor };

  optionsMagazzinoRientro: SelectItem<MagazzinoApiDescriptor>[];
  selectedMagazzinoRientro: MagazzinoApiDescriptor;

  readyData: boolean;
  hasSentAnyMaterials: boolean;
  /** Bando 1: esito fase 2 senza passaggio magazzino */
  bypassMagazzino: boolean;

  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private formBuilder: FormBuilder,
    private praticheService: PraticheService,
    private messageService: MessageService,
    private utilService: UtilService,
    private listeService: ListeService,
    private stiliService: StiliService,
    private backendMagazzino: MagazzinoService,
  ) {
    this.pratica = this.config.data.pratica;
    this.bypassMagazzino = this.isBypassMagazzino(this.pratica);
    const dataAppuntamento = this.pratica.dataAppuntamentoFase2
      ? this.convertFirestoreTimestampToDate(this.pratica.dataAppuntamentoFase2)
      : null;

    this.comunicaEsitoInstallazioneRouterForm = this.formBuilder.group({
      dataAppuntamento: [dataAppuntamento, [Validators.required]],
      esito: ["OK", [Validators.required]],
      note: [null],
      causaFallimento: [null],
      causaKO: [null],
    });
    this.datiScuolaForm = this.formBuilder.group({
      indirizzo: [this.pratica.indirizzo, [Validators.required]],
      comune: [this.pratica.comune, [Validators.required]],
      backup: [this.pratica.backup ? "SI" : "NO"],
    });
    this.comunicaEsitoInstallazioneRouterForm
      .get("esito")
      ?.valueChanges.subscribe((value) => {
        if (value === "OK") {
          this.esitoOK = true;
          this.severityConferma = "Conferma";
        } else {
          this.esitoOK = false;
          this.labelConferma = "Conferma esito KO";
          this.severityConferma = "warning";
        }
      });

    this.scortaMateriali = {};
    this.magazziniById = {};

    this.installedSerials = {};
    this.installedAmounts = {};
    for (let rule of this.regoleRegistrazioneMateriali) {
      this.installedSerials[rule.nmu] = null;
      this.installedAmounts[rule.nmu] = 0;
    }

    this.optionsMagazzinoRientro = [];
    this.selectedMagazzinoRientro = null;

    this.readyData = false;
  }

  updateMaterialsChecks() {
    const diffs = {};
    this.hasMissingMaterials = false;
    this.hasMissingSerials = false;

    for (let rule of this.regoleRegistrazioneMateriali) {
      diffs[rule.nmu] =
        (this.scortaMateriali[rule.nmu]?.balance ?? 0) -
        (this.installedAmounts[rule.nmu] ?? 0);
      if (
        diffs[rule.nmu] < 0 ||
        (rule.valueRequired &&
          this.installedAmounts[rule.nmu] != rule.valueRequired)
      ) {
        this.hasMissingMaterials = true;
      }

      if (
        rule.requiresSerial &&
        (!this.installedSerials[rule.nmu] ||
          this.installedSerials[rule.nmu].trim().length == 0)
      ) {
        this.hasMissingSerials = true;
      }
    }
    this.materialsDiff = { ...diffs };
  }

  ngOnInit() {
    if (this.bypassMagazzino) {
      this.hasSentAnyMaterials = true;
      this.hasMissingMaterials = false;
      this.hasMissingSerials = false;
      this.readyData = true;
      if (this.pratica.cpeSn) {
        this.installedSerials["780098"] = this.pratica.cpeSn;
      }
      this.logger.info(
        "Bypass magazzino attivo per pratica " +
          this.pratica.cui +
          " (BANDO 1)",
      );
    } else {
      this.loadMateriali();
      this.hasSentAnyMaterials = true;
    }
    this.inizializzaSteps();
    this.loadCategorieKO();
    this.activeIndex = 0;
  }

  private isBypassMagazzino(pratica: PraticaFlowdy2_Firestore): boolean {
    return pratica?.bando === "BANDO 1";
  }

  loadMateriali() {
    this.logger.info("loadMateriali");
    const loaded = {
      scorta: false,
      modelli: false,
      magazzini: false,
      originiPratica: false,
    };

    const modelliById = {};
    const scorta = {};

    let originiPratica: string[] = [];

    const checkUpdateReadiness = () => {
      if (
        loaded.scorta &&
        loaded.modelli &&
        loaded.magazzini &&
        loaded.originiPratica
      ) {
        this.scortaMateriali = {};
        for (let key in modelliById) {
          this.scortaMateriali[key] = {
            modello: modelliById[key],
            balance: scorta[key] ?? 0,
          };
        }
        // console.log("scorta materiali: ", this.scortaMateriali);
        this.optionsMagazzinoRientro = Object.values(this.magazziniById)
          .map((item) => {
            return {
              label: item.codice,
              value: item,
            };
          })
          .sort((itemA, itemB) => {
            return itemA.label.localeCompare(itemB.label);
          });

        this.selectedMagazzinoRientro =
          this.magazziniById[originiPratica[0]] ??
          this.optionsMagazzinoRientro[0].value;

        this.updateMaterialsChecks();
        this.readyData = true;
        this.hasSentAnyMaterials = Object.values(this.scortaMateriali).some(
          (item) => {
            return item.balance > 0;
          },
        );
      }
    };

    this.backendMagazzino
      .magazzinoList(this.pratica.idAzienda)
      .subscribe((result) => {
        this.magazziniById = {};
        for (let item of result.listing) {
          this.magazziniById[`${item.id}`] = item;
        }
        loaded.magazzini = true;
        checkUpdateReadiness();
      });

    this.backendMagazzino
      .installabiliPraticaListing(this.pratica.id)
      .subscribe((result) => {
        for (let [nmu, qt] of Object.entries(result.listing)) {
          scorta[nmu] = qt;
        }
        loaded.scorta = true;
        checkUpdateReadiness();
      });

    this.backendMagazzino.modelloDispositivoList().subscribe((result) => {
      for (let item of result.listing) {
        modelliById[item.nmu] = item;
      }
      loaded.modelli = true;
      checkUpdateReadiness();
    });

    this.backendMagazzino
      .movimentazioniAttivePraticaListing(this.pratica.id)
      .subscribe((result) => {
        originiPratica = result.listing.map((item) => {
          return item["origine"];
        });
        loaded.originiPratica = true;
        checkUpdateReadiness();
      });
  }

  loadCategorieKO() {
    this.utilService
      .getCategorieAppuntamentoKO()
      .subscribe((categorieVincolo) => {
        this.categorieAppuntamentoKO = categorieVincolo;
        this.listeService.setOpzioniCausaKO(
          this.categorieAppuntamentoKO.map((categoria) => ({
            label: categoria.label,
            value: categoria.codice,
          })),
        );
      });
  }

  protected getPrimoCarattereNumerico(value: any): number {
    if (!value) return 0;
    const strValue = String(value);
    const primoCarattere = strValue.charAt(0);
    return parseInt(primoCarattere) || 0;
  }

  inizializzaSteps() {
    this.pagineComunicaEsitoInstallazioneRouter = [
      {
        label: "Esito",
      },
      {
        label: "Dati scuola",
      },
      {
        label: "Dati CPE",
      },
      {
        label: "Conferma dati",
      },
    ];
    this.activeIndex = 0;
    this.logger.info(
      "INIT CON " +
        this.activeIndex +
        " E " +
        this.pagineComunicaEsitoInstallazioneRouter.length +
        " E ESITO OK " +
        this.esitoOK,
    );
  }

  checkNextStep(): boolean {
    let disableNextStepButton = false;
    if (
      this.activeIndex ===
      this.pagineComunicaEsitoInstallazioneRouter.length - 1
    ) {
      disableNextStepButton = true;
    } else if (
      this.activeIndex === 0 &&
      (!this.esitoOK || !this.comunicaEsitoInstallazioneRouterForm.valid)
    ) {
      disableNextStepButton = true;
    }
    return disableNextStepButton;
  }

  changePage() {
    this.activeIndex = this.activeIndex + 1;
  }

  private convertFirestoreTimestampToDate(timestamp: Timestamp): Date {
    return timestamp.toDate();
  }

  // abbiamo conferma con SUCCESSO E NON.
  // nel caso del successo dobbiamo ANCHE mandare un pacco di altre informazioni quindi lo facciamo da qui
  // in caso di annullamento lasciamo che sia il backend di magazzino ad avvisare (perché basta il numero pratica)
  // comunicaEsitoInstallazioneOk e comunicaEsitoInstallazioneFail sono i due "wrapper",
  // mentre comunicaEsitoInstallazione è quello che parla effettivamente con il backend principale

  comunicaEsitoInstallazione(esitoInstallazione: AppuntamentoFase2) {
    this.praticheService
      .comunicaAppuntamentoFase2(this.pratica.id, esitoInstallazione)
      .subscribe({
        next: () => {
          this.isComunicandoInstallazioneRouter = false;
          this.dialogRef.close({ success: true });
        },
        error: () => {
          this.isComunicandoInstallazioneRouter = false;
          this.messageService.add({
            severity: "info",
            summary: "Errore",
            life: 10000,
            detail:
              "Errore in fase di comunicazione dell'esito dell'appuntamento di fase 2!",
          });
          this.dialogRef.close({ success: false });
        },
      });
  }

  comunicaEsitoInstallazioneOk(esitoInstallazione: AppuntamentoFase2) {
    if (this.bypassMagazzino) {
      this.comunicaEsitoInstallazione(esitoInstallazione);
      return;
    }

    // esito positivo facciamo PRIMA la chiusura delle  movimentazioni e se va anche il resto
    this.backendMagazzino
      .praticaConsegnaConferma(
        this.pratica.id,
        this.installedAmounts,
        this.selectedMagazzinoRientro.id,
      )
      .subscribe({
        next: (data) => {
          console.log("consegne confermate chiuse: ", data);
          this.comunicaEsitoInstallazione(esitoInstallazione);
        },
        error: (e: HttpErrorResponse) => {
          console.log("consegne errore: ", e);
          this.isComunicandoInstallazioneRouter = false;
          this.messageService.add({
            severity: "info",
            summary: "Errore",
            life: 10000,
            detail:
              "Errore in fase di comunicazione col magazzino per l'esito dell'appuntamento di fase 2!",
          });
          this.dialogRef.close({ success: false });
        },
      });
  }

  comunicaEsitoInstallazioneFail(esitoInstallazione: AppuntamentoFase2) {
    if (this.bypassMagazzino) {
      this.comunicaEsitoInstallazione(esitoInstallazione);
      return;
    }

    // esito negativo annulla tutte le consegne in sospeso per questa pratica
    // non si specificano i rientri perché ogni invio ritorna al magazzino di origine

    this.backendMagazzino.praticaConsegnaAnnulla(this.pratica.id).subscribe({
      next: (data) => {
        console.log("consegne confermate chiuse: ", data);
        this.comunicaEsitoInstallazione(esitoInstallazione);
      },
      error: (e: HttpErrorResponse) => {
        console.log("consegne errore: ", e);
        this.isComunicandoInstallazioneRouter = false;
        this.messageService.add({
          severity: "info",
          summary: "Errore",
          life: 10000,
          detail:
            "Errore in fase di comunicazione col magazzino per l'esito dell'appuntamento di fase 2!",
        });
        this.dialogRef.close({ success: false });
      },
    });
  }

  isConfermaOkDisabled(): boolean {
    if (
      this.isComunicandoInstallazioneRouter ||
      !this.comunicaEsitoInstallazioneRouterForm.valid ||
      !this.esitoOK
    ) {
      return true;
    }
    if (this.bypassMagazzino) {
      return false;
    }
    return (
      this.hasMissingSerials ||
      this.hasMissingMaterials ||
      !this.selectedMagazzinoRientro
    );
  }

  getSerialNumberRouter(): string | null {
    return (
      this.installedSerials["780098"]?.trim() ||
      this.pratica.cpeSn?.trim() ||
      null
    );
  }

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      this.isComunicandoInstallazioneRouter = true;
      let esitoInstallazione: AppuntamentoFase2 = new AppuntamentoFase2();
      esitoInstallazione.data =
        this.comunicaEsitoInstallazioneRouterForm.get("dataAppuntamento").value;
      esitoInstallazione.installazioneOK =
        this.comunicaEsitoInstallazioneRouterForm.get("esito").value === "OK"
          ? true
          : false;
      if (!esitoInstallazione.installazioneOK) {
        esitoInstallazione.causaFallimento =
          this.comunicaEsitoInstallazioneRouterForm.get(
            "causaFallimento",
          ).value;
        if (this.comunicaEsitoInstallazioneRouterForm.get("causaKO").value) {
          esitoInstallazione.categoriaVincolo =
            this.categorieAppuntamentoKO.find(
              (categoria) =>
                categoria.codice ===
                this.comunicaEsitoInstallazioneRouterForm.value.causaKO,
            );

          //esitoInstallazione.categoriaVincolo = this.comunicaEsitoInstallazioneRouterForm.get('causaKO').value;
          this.logger.info(esitoInstallazione.categoriaVincolo);
        }
      }
      esitoInstallazione.note =
        this.comunicaEsitoInstallazioneRouterForm.get("note").value;
      if (
        this.datiScuolaForm.get("indirizzo").value !== this.pratica.indirizzo
      ) {
        esitoInstallazione.indirizzoScuola =
          this.datiScuolaForm.get("indirizzo").value;
      }
      if (this.datiScuolaForm.get("comune").value !== this.pratica.comune) {
        esitoInstallazione.comuneScuola =
          this.datiScuolaForm.get("comune").value;
      }
      if (
        this.datiScuolaForm.get("backup").value.value === "SI"
          ? true
          : false !== this.pratica.backup
      ) {
        esitoInstallazione.backup =
          this.datiScuolaForm.get("backup").value === "SI" ? true : false;
      }

      esitoInstallazione.serialNumber = this.getSerialNumberRouter();
      esitoInstallazione.partNumber = this.pratica.cpePn || null;

      // switching different workflows
      if (esitoInstallazione.installazioneOK) {
        this.comunicaEsitoInstallazioneOk(esitoInstallazione);
      } else {
        this.comunicaEsitoInstallazioneFail(esitoInstallazione);
      }

      // console.log("data backend main: ", esitoInstallazione);
      // console.log("data backend magazzino:", );
    }
  }
}

interface RegolaInstallazioneDispositivo {
  nmu: string;
  requiresSerial?: boolean;
  valueRequired?: number;
}
